<template>
    <div class='footer_box'>
        <nav class='mui-bar mui-bar-tab'>
            <router-link to="/tracking">
                <img src='@/assets/images/track.svg' />
                <p class='mui-tab-label'>追踪</p>
            </router-link>
            <router-link to='/playback'>
                <img src='@/assets/images/playback.svg' />
                <p class='mui-tab-label'>回放</p>
            </router-link>
            <router-link to='/warning'>
                <img src='@/assets/images/alarm.svg' />
                <p class='mui-tab-label'>告警</p>
            </router-link>
            <router-link to='/set'>
                <img src='@/assets/images/set-up.svg' />
                <p class='mui-tab-label'>设置</p>
            </router-link>
        </nav>
    </div>
</template>

<script>
export default {
    name: 'Footer'
};
</script>

<style scoped>
.mui-bar {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    height: 120px;
    border: none;
    box-sizing: border-box;
}
.mui-bar a {
    flex: 1;
    text-align: center;
    cursor: pointer;
}
.router-link-active {
    background: url('../assets/images/clickbg.svg') center bottom no-repeat;
    background-size: 128px 128px;
}
.mui-bar img {
    width: 48px;
    height: 48px;
    margin: 10px;
}
.mui-bar p {
    font-size: 25px;
    color: black;
    vertical-align: bottom;
}
</style>


// WEBPACK FOOTER //
// src/components/footer.vue